<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<div class="modal-max-width-container">
  <mat-dialog-content class="mat-typography dialog-content">
    @if (contentData()) {
      <div class="title">
        <h3>{{ contentData()?.title }}</h3>
      </div>
      <div class="content" [innerHTML]="contentData()?.text">
      </div>
    }
    @if (isLoading()) {
      <app-loader></app-loader>
    }
  </mat-dialog-content>
</div>
